import { render, staticRenderFns } from "./PromoteViewItem.vue?vue&type=template&id=bfa2ccde&scoped=true&"
import script from "./PromoteViewItem.vue?vue&type=script&lang=ts&"
export * from "./PromoteViewItem.vue?vue&type=script&lang=ts&"
import style0 from "./PromoteViewItem.vue?vue&type=style&index=0&id=bfa2ccde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa2ccde",
  null
  
)

export default component.exports